import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type { AnchorHTMLAttributes, ClassAttributes } from 'react';
import type { ExtraProps } from 'react-markdown';
import { shouldOpenOtherTab } from '@/functions/shouldOpenOtherTab';

/**
 * 外部リンクは別タブで開く
 */
export const LinkRenderer = ({
  size = 'medium',
  ...props
}: {
  size?: 'small' | 'medium';
} & ClassAttributes<HTMLAnchorElement> &
  AnchorHTMLAttributes<HTMLAnchorElement> &
  ExtraProps) => {
  const theme = useTheme();
  if (shouldOpenOtherTab(props.href || '')) {
    return (
      <a
        {...props}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          ...props.style,
          fontSize:
            size === 'small'
              ? theme.typography.body2.fontSize
              : theme.typography.body1.fontSize
        }}
      >
        {props.children}
      </a>
    );
  }
  return (
    <a
      {...props}
      style={{
        ...props.style,
        fontSize:
          size === 'small'
            ? theme.typography.body2.fontSize
            : theme.typography.body1.fontSize
      }}
    >
      {props.children}
    </a>
  );
};

export const LiRenderer = (props: any) => {
  const theme = useTheme();
  return (
    <Typography
      component="li"
      variant="body1"
      sx={{
        my: 1.5,
        fontSize:
          props.size === 'small'
            ? theme.typography.body2.fontSize
            : theme.typography.body1.fontSize
      }}
      {...props}
    />
  );
};

export const H2Renderer = (props: any) => {
  const theme = useTheme();
  return (
    <Typography
      component="h2"
      variant="h6"
      fontWeight={theme.typography.fontWeightBold}
      sx={{ my: 2 }}
      {...props}
    />
  );
};

export const H3Renderer = (props: any) => {
  const theme = useTheme();
  return (
    <Typography
      component="h3"
      variant="body1"
      fontWeight={theme.typography.fontWeightBold}
      sx={{ mt: 2, mb: 1.5 }}
      {...props}
    />
  );
};

export const PRenderer = (props: any) => {
  const theme = useTheme();
  return (
    <Typography
      component="p"
      variant="body1"
      sx={{
        my: 1.5,
        fontSize:
          props.size === 'small'
            ? theme.typography.body2.fontSize
            : theme.typography.body1.fontSize
      }}
      {...props}
    />
  );
};
